import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { find as _find, cloneDeep as _cloneDeep, findIndex as _findIndex } from 'lodash';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormInput from 'components/forms/FormInput';
import List from "../../List";

class CreacheckConditions extends React.Component {

  changeUserSetRolesPrice = (name, value, userRoleSet) => {
    const {updateEntity, entity} = this.props;
    const currentUserRoleSet = _cloneDeep(userRoleSet);
    const userRoleSets = entity.getUserRolePrices();
    currentUserRoleSet[name] = value;
    const index = _findIndex(userRoleSets, {id: userRoleSet.id});
    if(index >= 0){
      userRoleSets[index] = currentUserRoleSet;
    } else {
      userRoleSets.push(currentUserRoleSet);
    }
    updateEntity('userRolePrices', userRoleSets );
  }

  render() {
    const {
      intl: { messages },
      inModal,
      webApp,
      entity,
      updateEntity,
      disabled,
      roles
    } = this.props;

    return (
      <Row>
        <List noRender listName="roles" url="/api/roles.json" list={roles} />
        <Col xs={12} md={inModal ? 12 : 4}>
          <div className="panel panel-transparent">
            <div className="panel-body">
              <p>Abo-Conditions</p>
              <div className="form-group-attached">
                <div className="form-group form-group-default padding-10">
                  <FormSwitchery
                    label={messages.is_user_based}
                    name="isUserBased"
                    checked={entity.getIsUserBased()}
                    value
                    onChange={updateEntity}
                    disabled={disabled}
                  />
                </div>
                <FormInput
                  label={messages.monthly_fee}
                  name="monthlyFee"
                  value={entity.getMonthlyFee()}
                  meta={entity.getMonthlyFeeMetaInformation()}
                  validation={entity.getMonthlyFeeValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  min="0"
                  step={0.01}
                  prefixAddon={webApp.currencySymbol}
                />
                <FormInput
                  label={messages.starting_fee}
                  name="startingFee"
                  value={entity.getStartingFee()}
                  meta={entity.getStartingFeeMetaInformation()}
                  validation={entity.getStartingFeeValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  min="0"
                  step={0.01}
                  prefixAddon={webApp.currencySymbol}
                />
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} md={inModal ? 12 : 4}>
          <div className="panel panel-transparent">
            <div className="panel-body">
              <p className="hidden-xs">&nbsp;</p>
              {roles.pending ? <i className="m-l-10 fa fa-circle-notch fa-spin"/> :
                <div className="form-group-attached">
                {
                  roles.data.sets.map((userRoleSet, i) => {
                    let currentValue;
                    if(typeof entity.getUserRolePrices === 'function' ) {
                      currentValue = _find(entity.getUserRolePrices(), {id: userRoleSet.id});
                    }
                    if(currentValue === undefined){
                      currentValue = {pricePerUser:  0};
                    }
                    return (
                        <FormInput
                          label={messages.price_per_user + ' ' + userRoleSet.name}
                          name="pricePerUser"
                          value={currentValue.pricePerUser}
                          onChange={(name, value) => {
                            this.changeUserSetRolesPrice(name, value, userRoleSet)
                          }}
                          disabled={disabled}
                          type="number"
                          min="0"
                          step={0.01}
                          prefixAddon={webApp.currencySymbol}
                        />
                    )
                  })
                }
                </div>
              }

            </div>
          </div>
        </Col>

        <Col xs={12} md={inModal ? 12 : 4}>
          <div className="panel panel-transparent">
            <div className="panel-body">
              <p className="hidden-xs">&nbsp;</p>
              <div className="form-group-attached">
                <FormInput
                  label={messages.included_templates_count}
                  name="includedTemplatesCount"
                  value={entity.getIncludedTemplatesCount()}
                  meta={entity.getIncludedTemplatesCountMetaInformation()}
                  validation={entity.getIncludedTemplatesCountValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  min="0"
                />
                <FormInput
                  label={messages.simple_templates_count}
                  name="simpleTemplatesCount"
                  value={entity.getSimpleTemplatesCount()}
                  meta={entity.getSimpleTemplatesCountMetaInformation()}
                  validation={entity.getSimpleTemplatesCountValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  min="0"
                />
                <FormInput
                  label={messages.middle_templates_count}
                  name="middleTemplatesCount"
                  value={entity.getMiddleTemplatesCount()}
                  meta={entity.getMiddleTemplatesCountMetaInformation()}
                  validation={entity.getMiddleTemplatesCountValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  min="0"
                />
                <FormInput
                  label={messages.complex_templates_count}
                  name="complexTemplatesCount"
                  value={entity.getComplexTemplatesCount()}
                  meta={entity.getComplexTemplatesCountMetaInformation()}
                  validation={entity.getComplexTemplatesCountValidationResult()}
                  onChange={updateEntity}
                  disabled={disabled}
                  type="number"
                  min="0"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    roles: state.list.roles,
  };
};

export default injectIntl(connect(mapStateToProps)(CreacheckConditions));
